export enum PermissionsEnum {
  INDEX_USER = 'INDEX_USER',
  SHOW_USER = 'SHOW_USER',
  STORE_USER = 'STORE_USER',
  UPDATE_USER = 'UPDATE_USER',
  DELETE_USER = 'DELETE_USER',
  SHOW_ROLE = 'SHOW_ROLE',
  STORE_ROLE = 'STORE_ROLE',
  DELETE_ROLE = 'DELETE_ROLE',
  UPDATE_ROLE = 'UPDATE_ROLE',
  INDEX_ROLE = 'INDEX_ROLE',
  EDIT_ROLE_PERMISSION = 'EDIT_ROLE_PERMISSION',
  SHOW_ROLE_PERMISSION = 'SHOW_ROLE_PERMISSION',
  SHOW_USER_ROLE = 'SHOW_USER_ROLE',
  EDIT_USER_ROLE = 'EDIT_USER_ROLE',
  SHOW_PERMISSIONS = 'SHOW_PERMISSIONS',
  SEND_USER_EMAIL_OTP = 'SEND_USER_EMAIL_OTP',
  INDEX_COMPANY = 'INDEX_COMPANY',
  SHOW_COMPANY = 'SHOW_COMPANY',
  STORE_COMPANY = 'STORE_COMPANY',
  DELETE_COMPANY = 'DELETE_COMPANY',
  UPDATE_COMPANY = 'UPDATE_COMPANY',
  INDEX_APPOINTMENT = 'INDEX_APPOINTMENT',
  SHOW_APPOINTMENT = 'SHOW_APPOINTMENT',
  STORE_APPOINTMENT = 'STORE_APPOINTMENT',
  UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT',
  DELETE_APPOINTMENT = 'DELETE_APPOINTMENT',
  INDEX_CLIENT = 'INDEX_CLIENT',
  SHOW_CLIENT = 'SHOW_CLIENT',
  STORE_CLIENT = 'STORE_CLIENT',
  UPDATE_CLIENT = 'UPDATE_CLIENT',
  DELETE_CLIENT = 'DELETE_CLIENT',
  INDEX_PAYMENT = 'INDEX_PAYMENT',
  SHOW_PAYMENT = 'SHOW_PAYMENT',
  STORE_PAYMENT = 'STORE_PAYMENT',
  UPDATE_PAYMENT = 'UPDATE_PAYMENT',
  DELETE_PAYMENT = 'DELETE_PAYMENT',
  INDEX_USER_COMPANY = 'INDEX_USER_COMPANY',
  INDEX_SUPPLIER = 'INDEX_SUPPLIER',
  INDEX_PLAN = 'INDEX_PLAN',
  INDEX_SUBSCRIPTION = 'INDEX_SUBSCRIPTION',
  INDEX_META_TEST = 'INDEX_META_TEST',
  SHOW_META_TEST = 'SHOW_META_TEST',
  STORE_META_TEST = 'STORE_META_TEST',
  UPDATE_META_TEST = 'UPDATE_META_TEST',
  DELETE_META_TEST = 'DELETE_META_TEST',
}
